// documents-dock-route — which record's documents the floating Documents
// dock shows for a URL. Piggybacks on the Notes dock's route resolver
// (same six record routes) and maps its API segment onto the Documents
// tab's entity type. Pure; node-pool tested.
//
// Ongoing Care is the one record with no documents of its own: a care
// cycle IS a household's yearly plan, so its dock shows the HOUSEHOLD's
// documents. That needs the cycle's household id, which the route does
// not carry — the dock resolves it with one detail fetch (see
// DocumentsDock) and this map says "via household".
//
// CONSUMER: internal-ui.

import type { NoteEntitySegment } from "@shared/types/notes";
import { notesDockTargetForPath } from "../notes/notes-dock-route";

/** The Documents tab entity types a record ROUTE can reach (a subset of
 *  DocumentsTab's own union — the compliance-checklist type has no route).
 *  Declared here, not imported from the .tsx, so the node-pool test and the
 *  root tsconfig can type this module without JSX. */
export type DocumentsRouteEntityType =
  | "household"
  | "contact"
  | "opportunity"
  | "transaction"
  | "service_record";

export interface DocumentsDockTarget {
  /** The documents entity, or "household-of-rhythm" when it must be resolved. */
  entityType: DocumentsRouteEntityType | "household-of-rhythm";
  entityId: string;
  /** The route kind, for the dock's label. */
  kind: NoteEntitySegment;
}

const ENTITY_BY_SEGMENT: Record<
  NoteEntitySegment,
  DocumentsRouteEntityType | "household-of-rhythm"
> = {
  households: "household",
  contacts: "contact",
  "service-records": "service_record",
  opportunities: "opportunity",
  transactions: "transaction",
  "rhythm-instances": "household-of-rhythm",
};

export function documentsDockTargetForPath(pathname: string): DocumentsDockTarget | null {
  const t = notesDockTargetForPath(pathname);
  if (!t) return null;
  return { entityType: ENTITY_BY_SEGMENT[t.kind], entityId: t.entityId, kind: t.kind };
}
